import React, { useRef, useState, useEffect, useCallback } from "react";
import * as travelServices from "../../../../services/travel-service";
import debounce from "lodash/debounce";
import { InputText } from "primereact/inputtext";
import { withTranslation } from "react-i18next";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import ApplicantDataWrapper from "./ApplicantData.style";
import moment from "moment";

import { useDispatch, useSelector } from "react-redux";
import { updateApplicant, setLoading } from "../../../../redux/actions/travel";
import { isEmpty } from "lodash";
import { classNames } from "primereact/utils";
import * as globalUtils from "../../../../helpers/utils";
import { Dropdown } from "primereact/dropdown";

const ApplicantData = ({
  t,
  i18n,
  formik,
  isFieldValid,
  errorMessage,
  isValidCaptcha = false,
  setIsValidCaptcha = () => {},
}) => {
  const toast = useRef(null);
  const applicants = useSelector((state) => state.travel.applicants);
  const dispatch = useDispatch();
  const [disableFields, setDisableFields] = useState(false);
  const timerRef = useRef(null);
  const { businessLine } = useSelector((state) => state.travel);

  const handleNationId = useCallback(
    debounce((value) => {
      formik.setFieldTouched("nationalId", true);
      formik.setFieldValue("nationalId", value);
    }, 500),
    []
  );

  const handleYearBirth = useCallback(
    debounce((date) => {
      formik.setFieldTouched("yearBirth", true);
      formik.setFieldValue(
        "yearBirth",
        moment(date.value).format("YYYY-MM-DD")
      );
    }, 500),
    []
  );

  const numbersTemplate = (option, props) => {
    if (option) {
      return <div className="numbers_drop">{option.label}</div>;
    }
    return <span>{props.placeholder}</span>;
  };

  const isValidSaudiIDOrIQama = (idNumber) => {
    // Regular expression to match Saudi ID or Iqama numbers
    const saudiIDRegex = /^[1][0-9]{9}$/;
    const iqamaRegex = /^[2][0-9]{9}$/;

    // Check if the provided ID number matches either Saudi ID or Iqama format
    return saudiIDRegex.test(idNumber) || iqamaRegex.test(idNumber);
  };
  function submitDataToAPI() {
    if (!isValidSaudiIDOrIQama(formik.values.nationalId)) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in the national ID and date of birth correctly.",
        life: 10000,
      });
      return;
    }

    dispatch(setLoading(true));
    //Set Data to API

    travelServices
      .getPersonalData(
        {
          dobGreg: formik.values.month + "-" + formik.values.year,
          languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
          IDNO: formik.values.nationalId,
          Isdep: "False",
        },
        businessLine
      )
      .then((response) => {
        if (response.data.resultCode == "S") {
          var parts = response.data.PersonalInformation.dobGreg.split("-");
          var newDate = parts[2] + "-" + parts[1] + "-" + parts[0];
          response.data.PersonalInformation.dobGreg = newDate;
          // console.log(response.data.PersonalInformation.dobGreg,"response.data.PersonalInformation.dobGreg");
          // return
          const selfApplicant = {
            ...response.data.PersonalInformation,
            nationalId: formik.values.nationalId,
          };
          applicants.self = selfApplicant;
          dispatch(updateApplicant(applicants));
          dispatch(setLoading(false));
          setDisableFields(true);

          // for Google tagging (after retreving user details)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "travel_new_RetriveCustomerInfoComplete_v2",
            item_name: "Travel Insurance New",
            item_category: "Travel Insurance",
            item_class: "Individual",
            funnel_step: "step_1",
          });
        } else {
          // for Google tagging (failed to retreive user details)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: "Travel Insurance New",
            funnel_step: "step_1",
            error_messages: response.data.resultMessage,
          });
          // window.grecaptcha.reset();
          dispatch(setLoading(false));
          formik.values.yearBirth = null;
          toast.current.show({
            severity: "error",
            summary: t("ERROR.error"),
            detail: t("ERROR.ID"),
            life: 10000,
          });
        }
      })
      .catch((err) => {
        // for Google tagging (failed to retreive user details)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: "Travel Insurance New",
          funnel_step: "step_1",
          error_messages: JSON.stringify(err),
        });
        // window.grecaptcha.reset();
        // formik.setFieldValue("captcha", false);
        dispatch(setLoading(false));
        formik.values.yearBirth = null;
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "service error",
          life: 10000,
        });
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  }

  const getPersonalDetails = () => {
    const { month, year, nationalId } = formik.values;
    if (isEmpty(applicants.self) && month && year && nationalId) {
      submitDataToAPI();
    } else if (month && year && nationalId) {
      setDisableFields(true);
    }
  };
  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    const nationalIdLength = formik.values.nationalId.length;

    if (nationalIdLength >= 10) {
      timerRef.current = setTimeout(() => {
        getPersonalDetails();
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [formik.values.month, formik.values.year, formik.values.nationalId]);

  useEffect(() => {
    if (!applicants.self || !applicants.self.nationalId) {
      setDisableFields(false);
      formik.setFieldValue("nationalId", "");
      formik.setFieldTouched("nationalId", false);
      formik.setFieldTouched("year", false);
      formik.setFieldValue("year", "");
      formik.setFieldTouched("month", false);
      formik.setFieldValue("month", "");
    }
  }, [applicants]);

  const startYear = 1900;
  const endYear = new Date().getFullYear();
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, index) => startYear + index
  );
  // console.log(years,"Asdasd");

  const YearsS = years.map((year) => ({ label: year.toString(), value: year }));

  return (
    <ApplicantDataWrapper className="row">
      <Toast ref={toast} />
      <div className="col-md-6">
        <div className="field text-initial">
          <InputText
            maxLength={10}
            disabled={disableFields}
            name="nationalId"
            className={`form-control ${classNames({
              "p-invalid": isFieldValid("nationalId"),
              lato: formik.values.nationalId,
            })}`}
            placeholder={t("national-id")}
            value={formik.values.nationalId}
            onChange={(e) => {
              handleNationId(e.target.value);
              formik.handleChange(e);
            }}
          />
          {errorMessage("nationalId")}
        </div>
      </div>
      <div className="col-md-6">
        <div className="row">
          <div className="col-sm-8">
            <div className="field">
              <span className="p-float-label">
                <Dropdown
                  name="year"
                  value={formik.values.year}
                  disabled={disableFields}
                  className={classNames({
                    "p-invalid": isFieldValid("year"),
                  })}
                  onChange={(e) => formik.setFieldValue("year", e.target.value)}
                  options={YearsS}
                  optionLabel="label"
                  optionValue="value"
                  filterBy="label"
                  itemTemplate={numbersTemplate}
                  filter
                />
                <label htmlFor="">{t("YEAROFBIRTH")}</label>
              </span>
              {/* {getFormErrorMessage("yob")} */}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="field">
              <span className="p-float-label">
                <Dropdown
                  name="month"
                  value={formik.values.month}
                  disabled={disableFields}
                  className={classNames({
                    "p-invalid": isFieldValid("month"),
                  })}
                  // // placeholder={t("PERSONAL_DETAIL.YEAROFBIRTH")}
                  onChange={formik.handleChange}
                  options={globalUtils.months}
                  optionLabel="label"
                  optionValue="value"
                  filter
                  filterBy="label"
                  itemTemplate={numbersTemplate}
                />
                <label htmlFor="">{t("MONTH_BIRTH")}</label>
              </span>
              {/* {getFormErrorMessage("mob")} */}
            </div>
          </div>
        </div>
        {/* <div className="field text-initial">
          <Calendar
            className={`w-100 custom-calendar-input ${classNames({
              "p-invalid": isFieldValid("yearBirth"),
            })}`}
            required={true}
            disabled={disableFields}
            placeholder={t("DateOfBirth")}
            dateFormat="yy-mm-dd"
            inputClassName={`${classNames({
              "p-invalid": isFieldValid("yearBirth"),
              lato: formik.values.yearBirth,
            })}`}
            inputId="yearBirth"
            maxDate={new Date()}
            value={
              formik.values.yearBirth ? new Date(formik.values.yearBirth) : ""
            }
            readOnlyInput
            showIcon
            onChange={(value) => handleYearBirth(value)}
          />

          {errorMessage("yearBirth")}
        </div> */}
      </div>
    </ApplicantDataWrapper>
  );
};
export default withTranslation()(ApplicantData);
